import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePartnerAuth } from '../../context/PartnerAuthContext';
import { labelBase, borderBase, inputBase } from '../../components/shared/helpers';
// TEMPORARY — partner system-migration notice. Remove after 03-10-2026.
import PartnerMigrationNotice from './PartnerMigrationNotice';

export default function PartnerLogin() {
  const { signIn } = usePartnerAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleLogin = async () => {
    const next = {};
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) next.email = 'Please enter a valid email address';
    if (!password) next.password = 'Please enter your password';
    setErrors(next);
    if (Object.keys(next).length > 0) return;

    setSubmitError('');
    setSubmitting(true);
    try {
      const { error } = await signIn(email, password);
      if (error) {
        setSubmitError('Incorrect email or password.');
        return;
      }
      navigate('/partner');
    } catch (err) {
      setSubmitError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full max-w-[480px] p-px rounded-2xl bg-gradient-to-b from-[rgba(212,168,67,0.32)] via-[rgba(255,255,255,0.06)] to-[rgba(255,255,255,0.02)] card-enter">
      <PartnerMigrationNotice />
      <div className="bg-[#0D1E35] rounded-[15px] shadow-[0_40px_80px_rgba(0,0,0,0.55)] px-7 py-8">

        <p className="font-dm-sans text-[12px] uppercase tracking-[0.18em] text-[rgba(201,168,76,0.85)] mb-2">
          Partner Portal
        </p>
        <h1 className="font-cormorant font-normal text-[1.8rem] leading-[1.1] tracking-[-0.01em] text-white mb-1.5">
          Partner sign in
        </h1>
        <p className="font-dm-sans text-sm text-white/55 font-light mb-7 leading-relaxed">
          For registered travel partners and agencies
        </p>

        <div className="flex flex-col gap-5">

          <div className="group flex flex-col gap-2">
            <label className={labelBase}>Email</label>
            <div className={borderBase}>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleLogin(); }}
                className={inputBase}
                autoComplete="email"
              />
            </div>
            {errors.email && (
              <p className="font-dm-sans text-sm text-white/55 font-light leading-relaxed">{errors.email}</p>
            )}
          </div>

          <div className="group flex flex-col gap-2">
            <label className={labelBase}>Password</label>
            <div className={borderBase}>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleLogin(); }}
                className={inputBase}
                autoComplete="current-password"
              />
            </div>
            {errors.password && (
              <p className="font-dm-sans text-sm text-white/55 font-light leading-relaxed">{errors.password}</p>
            )}
          </div>

        </div>

        <button
          type="button"
          onClick={handleLogin}
          disabled={submitting}
          className="w-full mt-8 py-[14px] bg-[#C9A84C] text-[#0A1628] font-dm-sans font-medium text-[12.5px] tracking-[0.15em] uppercase rounded-full active:scale-[0.97] hover:bg-[#B8973E] transition-[transform,background-color] duration-[160ms] ease-[cubic-bezier(0.23,1,0.32,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(201,168,76,0.5)] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0D1E35]"
        >
          {submitting ? 'Signing in...' : 'Log in'}
        </button>

        {submitError && (
          <p className="font-dm-sans text-center text-sm text-white/55 mt-3.5 leading-relaxed">
            {submitError}
          </p>
        )}

        <div className="flex items-center justify-center gap-1.5 mt-6">
          <span className="font-dm-sans text-sm text-white/55">New to Alfresco Grand?</span>
          <Link
            to="/partner/register"
            className="font-dm-sans text-sm font-medium text-[#D4A843] hover:text-[#C9A84C] transition-colors duration-300"
          >
            Register as a partner
          </Link>
        </div>

        <p className="text-center mt-2.5">
          <Link
            to="/partner/forgot"
            className="font-dm-sans text-sm text-white/45 hover:text-white/70 transition-colors duration-300"
          >
            Forgot password?
          </Link>
        </p>

        <div className="mt-6 pt-4 border-t border-white/[0.07] text-center">
          <Link
            to="/"
            className="font-dm-sans text-[13px] text-white/40 hover:text-[rgba(201,168,76,0.85)] transition-colors duration-300"
          >
            ← Back to main site
          </Link>
        </div>

      </div>
    </div>
  );
}
